import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Layout from "./Shared/Layout";
import { get } from "../_services/apiService";
import { API_URL } from "../_services/apiUrl";
import { toast } from "react-toastify";

const FAQAccordion = () => {
    const [activeIndex, setActiveIndex] = useState(0);

    const [faqsData, setFaqsData] = useState([]);

    const GetFaqDetail = async () => {
        try {
            const response = await get(API_URL.GetFaqDetail);
            if (response.isSuccess === 1) {
                setFaqsData(response?.data)
            }
        } catch (error) {
            toast.error('Category data not found at this moment');
        }
    };

    useEffect(() => {
        GetFaqDetail();
    }, []);

    // Toggle the active accordion
    const toggleAccordion = (index) => {
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <Layout>
            <div className="contact-banner-sec layout_main">
                <div className="container">
                    <div className="page-header">
                        <h1>FAQ</h1>
                    </div>
                    <section className="faq_wepper">
                        <div className="accordion" id="accordionExample">
                            {faqsData?.map((faq, index) => (
                                <div className="accordion-item" key={faq.id}>
                                    <h2 className="accordion-header">
                                        <button
                                            className={`accordion-button ${activeIndex === index ? "" : "collapsed"
                                                }`}
                                            type="button"
                                            onClick={() => toggleAccordion(index)}
                                            aria-expanded={activeIndex === index}
                                        >
                                            {faq.question}
                                            <img
                                                className="icon"
                                                src={
                                                    activeIndex === index
                                                        ? "images/close.png"
                                                        : "images/plus.png"
                                                }
                                                alt={activeIndex === index ? "Close" : "Open"}
                                            />
                                        </button>
                                    </h2>
                                    <div
                                        className={`accordion-collapse collapse ${activeIndex === index ? "show" : ""
                                            }`}
                                    >
                                        <div className="accordion-body">
                                            <p>{faq.answer}</p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </section>
                </div>
            </div>
        </Layout>
    );
};

export default FAQAccordion;
